var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightdirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2297 23.0394C15.0892 22.8988 15.0104 22.7082 15.0104 22.5094C15.0104 22.3107 15.0892 22.1201 15.2297 21.9794L19.1997 18.0094L15.2297 14.0394C15.156 13.9708 15.0969 13.888 15.0559 13.796C15.0149 13.704 14.9929 13.6047 14.9911 13.504C14.9893 13.4033 15.0079 13.3032 15.0456 13.2099C15.0833 13.1165 15.1394 13.0316 15.2107 12.9604C15.2819 12.8892 15.3667 12.833 15.4601 12.7953C15.5535 12.7576 15.6535 12.7391 15.7542 12.7409C15.8549 12.7426 15.9542 12.7647 16.0462 12.8057C16.1382 12.8467 16.221 12.9058 16.2897 12.9794L20.7897 17.4794C20.9301 17.6201 21.009 17.8107 21.009 18.0094C21.009 18.2082 20.9301 18.3988 20.7897 18.5394L16.2897 23.0394C16.1491 23.1799 15.9584 23.2588 15.7597 23.2588C15.5609 23.2588 15.3703 23.1799 15.2297 23.0394Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightdirection);
export default __webpack_public_path__ + "static/media/right direction.6004dc8325f340e6e3bb43f2f93602a3.svg";
export { ForwardRef as ReactComponent };